// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LicenciasPage_containerFilaBusqueda__cbjZJ {
  display: flex;

  align-items: center;
  padding: 0px;
  width: 100%;
  margin: 0px;
  justify-content: space-between;
}

.LicenciasPage_titulo__Ojskw {
  font-weight: bold;
  font-size: 1.2rem;
  color: var(--text-color);
  margin-bottom: 20px;
  justify-self: flex-start;
  text-align: left;
  width: 100%;
  display: flex;
}

.LicenciasPage_descripcion__vHfg\\+ {
  font-size: 1.1rem;
  color: var(--text-color);
  margin-bottom: 20px;
  justify-self: flex-start;
  text-align: left;
  width: 100%;
  display: flex;
}
.LicenciasPage_divInformacion__liLbN {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  width: 100%;
}
.LicenciasPage_labelSinEncuestas__83zVY {
  font-size: 1.5rem;
  font-weight: bold;
  padding-top: 100px;
  padding-bottom: 100px;
}
.LicenciasPage_divTodoEnUnaFila__ZfcAM {
  display: flex;
  flex-direction: row;

  width: 100%;
}

.LicenciasPage_divCampos__Dsn3Z {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  justify-items: flex-start;
  margin-left: 10px;
  margin-right: 10px;
}

.LicenciasPage_divCamposItem__wvRuQ {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
  text-wrap: wrap;
  word-wrap: break-word;
}

.LicenciasPage_atributo__wBir2 {
  font-size: 0.8rem;
  font-weight: bold;
  text-wrap: nowrap;
  text-align: left;
  color: var(--text-color-claro);
}

.LicenciasPage_valor__pLcQ2 {
  font-size: 0.8rem;
  color: var(--text-color-claro-2);
  margin-left: 5px;
  text-align: left;
  word-wrap: break-word;
  max-width: 100%;
}

.LicenciasPage_divBotonera__NKFPo {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  margin-top: 20px;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: 10px;
  margin-right: 10px;
}

.LicenciasPage_circleImage__OWL6t {
  height: 100px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
  border-radius: 8px; /* Esto crea el círculo */
  margin-right: 0px;
  margin-left: 0px;
  border-width: 1px;
  border-style: solid;
  margin-bottom: 10px;
}

.LicenciasPage_containerGrillaUsuarios__A2VhK {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
}

.LicenciasPage_containerUsuario__BBEc2 {
  width: 100%;
  height: 300px;
  border-radius: 15px;
  border-color: gray;
  border-width: 1px;
  border-style: solid;
  padding: 10px;
  margin: 10px; /* Agrega un poco de margen entre los botones */
}

.LicenciasPage_divColumn__h6ElL {
  flex-direction: column;
  margin-left: 10px;
  margin-right: 10px;
}

@media (min-width: 768px) {
  /* Ajusta este valor según tus necesidades */

  .LicenciasPage_divCampos__Dsn3Z {
    flex-direction: row;
    gap: 30px;
  }

  .LicenciasPage_containerGrillaUsuarios__A2VhK {
    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */
    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */
    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */
  }

  .LicenciasPage_containerUsuario__BBEc2 {
    height: 250px;
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 45%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 95%; /* Asegura que los botones no sean más anchos que el 30% */
    margin: 10px; /* Agrega un poco de margen entre los botones */
  }

  .LicenciasPage_circleImage__OWL6t {
    width: 40%; /* Ajusta el tamaño según tus necesidades */

    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */

    border-width: 1px;
    border-style: solid;
  }
}

@media (min-width: 1100px) {
  .LicenciasPage_containerUsuario__BBEc2 {
    /* Asume que esta es la clase de tus BotonCardComponent */
    flex: 1 1 30%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */
    max-width: 28%; /* Asegura que los botones no sean más anchos que el 30% */
  }
}

.LicenciasPage_resumenLicenciasSinUsar__x2hUu {
  font-size: 1rem;
  color: black;
  font-weight: bold;
  text-align: left;
  width: 100%;
}
.LicenciasPage_divAyuda__RDiAM {
  background-color: var(--amarillo-ayuda);
  width: 100%;
  color: var(--text-color);
  padding: 5px;
  border-radius: 5px;
  border-width: 1px;
  border-color: var(--gris);
  border-style: solid;

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.LicenciasPage_info__hDtq\\+ {
  display: flex;
  flex-direction: row;
  border: 1px;
  width: 100%;
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 20px;
  border-radius: 20px;
  border-style: solid;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.LicenciasPage_divInfoLicencia__mMcHF {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  height: auto;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/panel/licencias/LicenciasPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;;EAEb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;;EAEnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;;EAEzB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,8EAA8E;EAC7F,kBAAkB,EAAE,yBAAyB;EAC7C,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,YAAY,EAAE,+CAA+C;AAC/D;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;;EAE5C;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,mBAAmB,EAAE,sEAAsE;IAC3F,eAAe,EAAE,mFAAmF;IACpG,2BAA2B,EAAE,qDAAqD;EACpF;;EAEA;IACE,aAAa;IACb,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;IAC1E,YAAY,EAAE,+CAA+C;EAC/D;;EAEA;IACE,UAAU,EAAE,2CAA2C;;IAEvD,iBAAiB,EAAE,wEAAwE;;IAE3F,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,yDAAyD;IACzD,aAAa,EAAE,0HAA0H;IACzI,cAAc,EAAE,0DAA0D;EAC5E;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,uCAAuC;EACvC,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;;EAEnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,SAAS;AACX","sourcesContent":[".containerFilaBusqueda {\n  display: flex;\n\n  align-items: center;\n  padding: 0px;\n  width: 100%;\n  margin: 0px;\n  justify-content: space-between;\n}\n\n.titulo {\n  font-weight: bold;\n  font-size: 1.2rem;\n  color: var(--text-color);\n  margin-bottom: 20px;\n  justify-self: flex-start;\n  text-align: left;\n  width: 100%;\n  display: flex;\n}\n\n.descripcion {\n  font-size: 1.1rem;\n  color: var(--text-color);\n  margin-bottom: 20px;\n  justify-self: flex-start;\n  text-align: left;\n  width: 100%;\n  display: flex;\n}\n.divInformacion {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  width: 100%;\n}\n.labelSinEncuestas {\n  font-size: 1.5rem;\n  font-weight: bold;\n  padding-top: 100px;\n  padding-bottom: 100px;\n}\n.divTodoEnUnaFila {\n  display: flex;\n  flex-direction: row;\n\n  width: 100%;\n}\n\n.divCampos {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n  justify-items: flex-start;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.divCamposItem {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n  text-wrap: wrap;\n  word-wrap: break-word;\n}\n\n.atributo {\n  font-size: 0.8rem;\n  font-weight: bold;\n  text-wrap: nowrap;\n  text-align: left;\n  color: var(--text-color-claro);\n}\n\n.valor {\n  font-size: 0.8rem;\n  color: var(--text-color-claro-2);\n  margin-left: 5px;\n  text-align: left;\n  word-wrap: break-word;\n  max-width: 100%;\n}\n\n.divBotonera {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n\n  margin-top: 20px;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.circleImage {\n  height: 100px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n  border-radius: 8px; /* Esto crea el círculo */\n  margin-right: 0px;\n  margin-left: 0px;\n  border-width: 1px;\n  border-style: solid;\n  margin-bottom: 10px;\n}\n\n.containerGrillaUsuarios {\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n  width: 100%;\n}\n\n.containerUsuario {\n  width: 100%;\n  height: 300px;\n  border-radius: 15px;\n  border-color: gray;\n  border-width: 1px;\n  border-style: solid;\n  padding: 10px;\n  margin: 10px; /* Agrega un poco de margen entre los botones */\n}\n\n.divColumn {\n  flex-direction: column;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n@media (min-width: 768px) {\n  /* Ajusta este valor según tus necesidades */\n\n  .divCampos {\n    flex-direction: row;\n    gap: 30px;\n  }\n\n  .containerGrillaUsuarios {\n    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */\n    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */\n    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */\n  }\n\n  .containerUsuario {\n    height: 250px;\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 45%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 95%; /* Asegura que los botones no sean más anchos que el 30% */\n    margin: 10px; /* Agrega un poco de margen entre los botones */\n  }\n\n  .circleImage {\n    width: 40%; /* Ajusta el tamaño según tus necesidades */\n\n    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n\n    border-width: 1px;\n    border-style: solid;\n  }\n}\n\n@media (min-width: 1100px) {\n  .containerUsuario {\n    /* Asume que esta es la clase de tus BotonCardComponent */\n    flex: 1 1 30%; /* Ajusta la base y la capacidad de crecimiento/reducción para que cada botón tome aproximadamente un tercio del espacio */\n    max-width: 28%; /* Asegura que los botones no sean más anchos que el 30% */\n  }\n}\n\n.resumenLicenciasSinUsar {\n  font-size: 1rem;\n  color: black;\n  font-weight: bold;\n  text-align: left;\n  width: 100%;\n}\n.divAyuda {\n  background-color: var(--amarillo-ayuda);\n  width: 100%;\n  color: var(--text-color);\n  padding: 5px;\n  border-radius: 5px;\n  border-width: 1px;\n  border-color: var(--gris);\n  border-style: solid;\n\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.info {\n  display: flex;\n  flex-direction: row;\n  border: 1px;\n  width: 100%;\n  padding: 20px;\n  margin-top: 10px;\n  margin-bottom: 20px;\n  border-radius: 20px;\n  border-style: solid;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.divInfoLicencia {\n  display: flex;\n  flex-direction: column;\n  margin-left: 20px;\n  height: auto;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerFilaBusqueda": `LicenciasPage_containerFilaBusqueda__cbjZJ`,
	"titulo": `LicenciasPage_titulo__Ojskw`,
	"descripcion": `LicenciasPage_descripcion__vHfg+`,
	"divInformacion": `LicenciasPage_divInformacion__liLbN`,
	"labelSinEncuestas": `LicenciasPage_labelSinEncuestas__83zVY`,
	"divTodoEnUnaFila": `LicenciasPage_divTodoEnUnaFila__ZfcAM`,
	"divCampos": `LicenciasPage_divCampos__Dsn3Z`,
	"divCamposItem": `LicenciasPage_divCamposItem__wvRuQ`,
	"atributo": `LicenciasPage_atributo__wBir2`,
	"valor": `LicenciasPage_valor__pLcQ2`,
	"divBotonera": `LicenciasPage_divBotonera__NKFPo`,
	"circleImage": `LicenciasPage_circleImage__OWL6t`,
	"containerGrillaUsuarios": `LicenciasPage_containerGrillaUsuarios__A2VhK`,
	"containerUsuario": `LicenciasPage_containerUsuario__BBEc2`,
	"divColumn": `LicenciasPage_divColumn__h6ElL`,
	"resumenLicenciasSinUsar": `LicenciasPage_resumenLicenciasSinUsar__x2hUu`,
	"divAyuda": `LicenciasPage_divAyuda__RDiAM`,
	"info": `LicenciasPage_info__hDtq+`,
	"divInfoLicencia": `LicenciasPage_divInfoLicencia__mMcHF`
};
export default ___CSS_LOADER_EXPORT___;
